import { Chip, ChipProps, TypographyProps } from '@mui/material';
import { FLOW_CHIPS } from 'new/components/flows/types/flowTypes';
import React, { FC, SVGAttributes, FunctionComponent, CSSProperties } from 'react';
import classes from './FlowTypeCard.module.scss';
import { default as cx } from 'classnames';

type FlowTypeCardTextProps = {
  StartIcon?: FunctionComponent<SVGAttributes<SVGElement>>;
  title: string | React.ReactNode;
  chipProps?: ChipProps;
  position?: 'start' | 'end';
  titleVariant: TypographyProps['variant'];
  sx?: CSSProperties;
  isSelected?: boolean;
};

export const FlowTypeCardText: FC<FlowTypeCardTextProps> = ({
  StartIcon,
  title,
  titleVariant,
  chipProps,
  position,
  sx,
  isSelected,
}) => {
  const textClassName = titleVariant === 'subtitle2' ? classes.titleText : classes.bodyText;

  return (
    <div className={classes.textContainer}>
      {StartIcon && <StartIcon className={classes.flowTypeIcon} />}
      <div className={textClassName} style={sx}>
        {position === 'end' && title}
        {chipProps?.label && (
          <Chip
            {...chipProps}
            size="small"
            className={cx(chipProps.className, {
              [classes.chipSelected]: isSelected,
            })}
          />
        )}
        {position === 'start' && title}
      </div>
    </div>
  );
};

export const chipDataTitleMap: Record<string, ChipProps> = {
  [FLOW_CHIPS.recommended]: {
    label: 'Recommended',
    color: 'primary',
    className: classes.chip,
  },
  [FLOW_CHIPS.early_access]: {
    label: 'Early Access',
    color: 'default',
    className: classes.chip,
  },
};
